import { getFeatureFlagValue } from '@citrite/feature-flags';
import { ProjectsRoutePath } from '@sharefiledev/projects-pilet-sdk';
import { FeatureFlag } from '../featureFlags';

/**
 * Sets up solution redirection when solution is installed
 * Handles both initial page load and navigation interception
 */
export const setupSolutionRedirection = (): void => {
	const solutionUrl = ProjectsRoutePath.ProjectsAsSolution;

	// Helper function to create redirect URL
	const createRedirectUrl = (path: string) =>
		path.replace(ProjectsRoutePath.LegacyProjects, solutionUrl) +
		window.location.search +
		window.location.hash;

	// Handle initial page load redirection
	const currentPath = window.location.pathname;
	if (currentPath.startsWith(ProjectsRoutePath.LegacyProjects)) {
		const redirectUrl = createRedirectUrl(currentPath);
		window.location.href = redirectUrl;
	}
};

export const projectRedirectUrl = () => {
	const shouldRedirect = getFeatureFlagValue(FeatureFlag.EnableProjectAsSolution);
	return shouldRedirect
		? ProjectsRoutePath.ProjectsAsSolution
		: ProjectsRoutePath.LegacyProjects;
};
